import type { TextField, LinkField } from '@core/jss-proxy';

export const DEFAULT_TEXT_FIELD: TextField = {
  value: '',
};

export const DEFAULT_LINK_FIELD: LinkField = {
  value: {
    text: '',
    href: '',
  },
};

export function getField<T>(
  fields: Record<string, any> | undefined,
  field: string,
  defaultValue: T
): T;
export function getField<T>(
  fields: Record<string, any> | undefined,
  field: string,
  defaultValue?: undefined
): T | undefined;
export function getField<T>(
  fields: Record<string, any> | undefined,
  field: string,
  defaultValue?: T
): T | undefined {
  if (fields) {
    return (fields[field] as T) ?? defaultValue;
  }
  return defaultValue;
}
